import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  public isMobile = signal<boolean>(window.innerWidth < 768);
  private readonly toggle: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
    window.addEventListener('resize', () => {
      this.isMobile.set(window.innerWidth < 768);
    });
  }

  get isMobileMenu(): boolean {
    return this.toggle.getValue();
  }

  public onToggleChange(event: boolean): void {
    this.toggle.next(event);
  }
}